/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rn_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Only canonical forms are accepted — 'IIII' and 'IL' are rejected, while 'IV' and 'XC' are valid. Lowercase input is accepted and treated as uppercase.`)
};

const es_rn_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Solo se aceptan formas canónicas — 'IIII' e 'IL' se rechazan, mientras que 'IV' y 'XC' son válidas. Se acepta la entrada en minúsculas y se trata como mayúscula.`)
};

const de_rn_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Es werden nur kanonische Formen akzeptiert — „IIII” und „IL” werden abgelehnt, während „IV” und „XC” gültig sind. Kleinbuchstaben werden akzeptiert und wie Großbuchstaben behandelt.`)
};

const nl_rn_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Alleen canonieke vormen worden geaccepteerd — IIII en IL worden afgewezen, terwijl IV en XC geldig zijn. Kleine letters worden geaccepteerd en behandeld als grote letters.`)
};

const fr_rn_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Seules les formes canoniques sont acceptées — « IIII » et « IL » sont rejetées, tandis que « IV » et « XC » sont valides. L'entrée en minuscules est acceptée et traitée comme des majuscules.`)
};

const it_rn_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Sono accettate solo le forme canoniche — IIII e IL vengono rifiutate, mentre IV e XC sono validi. L'input minuscolo è accettato e trattato come maiuscolo.`)
};

const pt_br2_rn_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Apenas formas canônicas são aceitas — 'IIII' e 'IL' são rejeitados, enquanto 'IV' e 'XC' são válidos. A entrada em minúsculas é aceita e tratada como maiúscula.`)
};

const pt_rn_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Apenas as formas canónicas são aceites — IIII e IL são rejeitadas, enquanto IV e XC são válidas. A entrada em minúsculas é aceite e tratada como maiúsculas.`)
};

const ja_rn_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。正規形のみが受け入れられます — 「IIII」と「IL」は拒否され、「IV」と「XC」は有効です。小文字の入力は受け入れられ、大文字として扱われます。`)
};

const zh_rn_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的。只接受规范写法——“IIII”和“IL”会被拒绝，而“IV”和“XC”是有效的。小写输入也会被接受，并按大写处理。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rn_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rn_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rn_faq2_a", locale)
	if (locale === "en") return en_rn_faq2_a(inputs)
	if (locale === "es") return es_rn_faq2_a(inputs)
	if (locale === "de") return de_rn_faq2_a(inputs)
	if (locale === "nl") return nl_rn_faq2_a(inputs)
	if (locale === "fr") return fr_rn_faq2_a(inputs)
	if (locale === "it") return it_rn_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_rn_faq2_a(inputs)
	if (locale === "pt") return pt_rn_faq2_a(inputs)
	if (locale === "ja") return ja_rn_faq2_a(inputs)
	return zh_rn_faq2_a(inputs)
};